import {useEffect} from 'react'
import {useDispatch,useSelector} from 'react-redux'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import LocaleDate from '../../LocaleDate/LocaleDate'
import Incrementer from '../../Incrementer/Incrementer'
import LocaleCurrency from '../../LocaleCurrency/LocaleCurrency'
import {
	useCreatePurchaseForm,
	useRemovePurchaseForm,
	usePurchaseItemForms,
	useSessions
} from '../hooks'
import {
	useCustomForms
} from '../../customForms/hooks'
import {useMemo,useState} from 'react'
import {useClients} from '../../users/hooks'
import useCurrentUser from '../../../hooks/useCurrentUser'
import {dateToAPIStandard,slidingQueryComparision} from '../../../util/util'
import useCurrencySettings from '../../../hooks/useCurrencySettings'
import useApiStatusEnvAwarePost from '../../../hooks/useApiStatusEnvAwarePost'
import useApiStatusDispatch from '../../../hooks/useApiStatusDispatch'
import {
	markSessionComplete,
	markSessionIncomplete,
	addSessions,
	editSession,
	removeSession,
	setClientSessionsModal
} from './sessionsSlice'
import DatePicker from 'react-datepicker'
import Select from 'react-select'
import {envAwarePost,dateToYMD} from '../../../util/util'
import useStripePromise from '../../../hooks/useStripeAccount'
import {getCurrencySymbol} from '../../../util/intl'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import InputGroup from 'react-bootstrap/InputGroup'
import { Elements, ElementsConsumer } from '@stripe/react-stripe-js'
import PurchaseModal from "../PurchaseModal"
import Session from "./Session"
import AddSessionModal from './AddSessionModal'
import ClientSessionsRow from './ClientSessionsRow'

//UI components that should only be shown to the account owner 
const AccountOwnerOptions = ()=>{
	const [loadingSpinner, setLoadingSpinner] = useState(false)
	const [showAddSessionModal,setShowAddSessionModal] = useState(false)
	const [updatingRate,setUpdatingRate] = useState(false)

	const [showFormsModal,setShowFormsModal] = useState(false)

	const {
		status:sessionFormsStatus,
		forms:sessionForms,
		allForms
	} = usePurchaseItemForms('session')

	const createPurchaseForm = useCreatePurchaseForm()
	const removePurchaseForm = useRemovePurchaseForm()

	// sets a new rate upon user submitting 
	const statusPost = useApiStatusEnvAwarePost()
	const handleRateSubmit = () => {
		setUpdatingRate(true)
		statusPost(
			'/api/trainer-gym/sessions/setRate/', 
			{
				session_rate: sessionRate,
				presentment_currency_id:presentmentCurrencyId
			},
			'session rate',
			'edit'
		).then(()=>{
		setUpdatingRate(false)
		})
	}
	const [sessionRate, setSessionRate] = useState("")
	const {acceptedCurrencies} = useCurrencySettings()
	//currency data for sessions
	const [presentmentCurrencyId,setPresentmentCurrencyId] = useState(1)
	const handleUpdateCurrency = e => {
		const currency_id = e.target.value
		setPresentmentCurrencyId(currency_id)
	}
	// load sessions and session rate
	useEffect( () => {
		setLoadingSpinner(true)
		envAwarePost('/api/trainer-gym/sessions/get/', {}).then((res) => {
			setLoadingSpinner(false)
			const {
				session_rate_presentment_currency_id,
				session_rate
			} = res.data
			setSessionRate(session_rate)
			setPresentmentCurrencyId(session_rate_presentment_currency_id)
		})
	}, [])
	return (
		<div className="ml-auto">
			<small>Session Rate</small>
			<div className="d-flex justify-content-between">
				<div className="input-group">
					<Form.Control 
						onChange={handleUpdateCurrency}
						className="input-group-prepend"
						value={presentmentCurrencyId}
						style={{maxWidth:'100px'}}
						as="select"
						size="sm"
					>
						{acceptedCurrencies.map( ac => (
							<option key={ac.id} value={ac.id}>
							{
								getCurrencySymbol(ac.ISO) === ac.ISO 
								? ac.ISO 
								: getCurrencySymbol(ac.ISO)
							}
							</option>
						))}
					</Form.Control>
					<Form.Control 
						size="sm"
						style={{padding:'.375rem .75rem',borderLeft:'1px solid #ced4da',maxWidth:'200px'}}
						onChange={e=>{
							setSessionRate(e.target.value)
						}}
						value={sessionRate}
					/>
					<div className="input-group-append">
						<Button 
							variant="outline-secondary" 
							onClick={handleRateSubmit}
							disabled={updatingRate}
							size="sm" 
						>
							{updatingRate
								? <Spinner animation="border" size="sm"/>
								: 'Update'
							}
						</Button>
					</div>
				</div>
				<OverlayTrigger overlay={
					<Tooltip>Manually Credit Sessions to a Client</Tooltip>
				}>
					<Button  
						onClick={()=>{ setShowAddSessionModal(true) }}
						className="ml-2"
						variant="outline-primary"
						style={{flex:'0 0 auto'}}
						size="sm"
					>
					Add Sessions to Client
					</Button>
				</OverlayTrigger>
				<AddSessionModal show={showAddSessionModal} onHide={()=>{setShowAddSessionModal(false)}}/>
			</div>
			<div>
				<OverlayTrigger overlay={
					<Tooltip>Clients will automatically be prompted to fill out any forms you select when they purchase sessions</Tooltip>
				}>
					<Button 
						onClick={setShowFormsModal.bind(null,true)}
						variant="link"
						size="sm"
					>
						Link forms/waivers to session purchases
					</Button>
				</OverlayTrigger>
			</div>
			<Modal show={showFormsModal} onHide={setShowFormsModal.bind(null,false)} centered>
				<Modal.Header closeButton>
					Session Forms & Waivers
				</Modal.Header>
				<Modal.Body>
					<small className="d-block mb-2">
						<i className="fa fa-info-circle mr-1"/>
						Clients will automatically be prompted to fill out these forms when they purchase sessions
					</small>
					<Select 
						onChange={(_,payload)=>{
							switch(payload.action){
								case 'select-option':
									createPurchaseForm({
										itemType:'session',
										formId:payload.option.value
									})
									break;
								case 'remove-value':
									removePurchaseForm({
										itemType:'session',
										formId:payload.removedValue.value
									})
									break;
							}
						}}
						value={
							sessionForms.map(
								form => ({
									value:form.form_id,
									label:form.form_title
								})
							)//end map
						}
						options={
							allForms.map(
								form => ({
									value:form.form_id,
									label:form.form_title
								})
							)//end map
						}//end options
						isMulti
					/>
					<div className="text-right mt-2">
						<Button onClick={setShowFormsModal.bind(null,false)} variant="outline-secondary">
							Done
						</Button>
					</div>
				</Modal.Body>
			</Modal>
		</div>
	)
}

const ClientPurchaseOptions = ()=>{
	//currency data for sessions
	const [presentmentCurrencyId,setPresentmentCurrencyId] = useState(1)
	const [sessionRate, setSessionRate] = useState("")
	const [sessionCount,setSessionCount] = useState('')
	const [showPurchaseModal,setShowPurchaseModal] = useState(false)
	const taxPercent = useSelector(state=>state.settings.app.tax_percent)
	const priceTotal = (
		(Boolean(sessionRate)&&Boolean(sessionCount)) ?
		parseFloat(sessionRate)*sessionCount*(1+taxPercent/100) :
		0
	)

	const clientUserId = useSelector(
		state => state.users.current_user.user_id
	)
	const clientName = useSelector(
		state => state.users.current_user.user_name
	)
	const trainerId = useSelector(
		state => state.users.current_user.bio_data.user_trainer_id
	)


	const {forms} = usePurchaseItemForms('session')
	const acceptedCurrency = useSelector(state=>state.settings.acceptedCurrencies.entities[presentmentCurrencyId])

	// load sessions and session rate
	useEffect( () => {
		envAwarePost('/api/trainer-gym/sessions/get/', {}).then((res) => {
			const {
				session_rate_presentment_currency_id,
				session_rate
			} = res.data
			setSessionRate(session_rate)
			setPresentmentCurrencyId(session_rate_presentment_currency_id)
		})
	}, [])
	const stripeAccount = useSelector(state => state.users.current_user.trainer_stripe_account)
	const stripePromise = useStripePromise(stripeAccount)

	const getPaymentIntent = () => {
		const payload = {
			action: 'getPaymentIntent',
			paymentAmount: priceTotal*100,
			clientEmail: clientUserId,
			trainer_id: trainerId,
			numSessions: sessionCount,
			clientName: clientName,
			paymentType: "sessions",
			package_currency_id:presentmentCurrencyId,
			purchase_description:`${sessionCount} Sessions`
		}
		return envAwarePost("api/purchases/trainer_page/", payload)
	}

	const [clientSecret,setClientSecret] = useState(null)
	const [loadingCheckout,setLoadingCheckout] = useState(false)
	useEffect(async()=>{
		if(sessionCount===0||!Boolean(sessionCount))return
		setLoadingCheckout(true)
		const res = await getPaymentIntent()
		if(res) setLoadingCheckout(false)
		setClientSecret(res.data)
	},[presentmentCurrencyId,sessionCount])
	return (
		<div>
			<strong className="d-block">
				Purchase Sessions {Boolean(sessionRate)&&
					<span>
						<LocaleCurrency amount={sessionRate} ISO={acceptedCurrency.ISO}/>/session {taxPercent>0&&`(plus ${taxPercent.toFixed(2)}% tax)`}
					</span>
				}
			</strong>
			<InputGroup size="sm">
				<Form.Control 
					value={sessionCount}
					onChange={ e => {
						setSessionCount(parseInt(e.target.value))
					}}
					placeholder="number of sessions" 
					type="number"
				/>
				<InputGroup.Append>
					<Button 
						onClick={()=>{setShowPurchaseModal(true)}} 
						variant="outline-success"
						disabled={loadingCheckout}
					>
						Purchase {priceTotal>0&&<LocaleCurrency amount={priceTotal.toFixed(2)} ISO={acceptedCurrency.ISO}/>}
						{loadingCheckout&&<Spinner className="ml-1" animation="border" size="sm"/>}
					</Button>
				</InputGroup.Append>
			</InputGroup>
			<hr className="my-2"/>
			{(Boolean(stripePromise)&&Boolean(clientSecret))&&
				<Elements stripe={stripePromise} options={{
						clientSecret
					}}>
					<ElementsConsumer>
						{({ elements, stripe }) => (
							<PurchaseModal
								meta={{forms}}
								totalPurchase={priceTotal}
								totalSessions={sessionCount}
								paymentType={"sessions"}
								show={showPurchaseModal}
								toggle={() => {
									setShowPurchaseModal(!showPurchaseModal)
								}}
								elements={elements}
								stripe={stripe}
								onSuccess={()=>{
									setSessionCount('')
								}}
							/>
						)}
					</ElementsConsumer>
				</Elements>
			}
		</div>
	)
}

const Sessions = ()=>{
	const {status,sessions,clientAggregates} = useSessions()
	const user = useCurrentUser()
	const isClient = user.account_type === 'client'

	const [clientQuery,setClientQuery] = useState('')
	const [dateQuery,setDateQuery] = useState(null)
	const [statusQuery,setStatusQuery] = useState('all')

	const sortComparer = (a,b)=>{
		const aVal = a.client.name?.toLowerCase()
		const bVal = b.client.name?.toLowerCase()
		const q = clientQuery.toLowerCase()
		if(!q){
			return aVal <= bVal ? -1 : 1
		}else{
			return slidingQueryComparision(aVal,bVal,q)
		}
	}

	const aggregates = clientAggregates.sort(sortComparer).slice(0,100)
	

	const isOwner = (
		user.gym_id != 0 ? 
		user.account_type === 'gym' :
		user.account_type === 'trainer'
	)

	return (
		<div className="d-flex flex-column pb-2" style={{height:'100%',overflow:'hidden'}}>
			{isClient&&<ClientPurchaseOptions/>}
			<div style={{flex:'0 0 auto'}} className="d-flex align-items-end mb-2 flex-wrap-reverse">
				{!isClient&&
					<div className="mr-1">
						<small className="d-block">Client Name</small>
						<Form.Control 
							onChange={e=>{ setClientQuery(e.target.value) }}
							placeholder="Search" 
							value={clientQuery}
							size="sm"
						/>
					</div>
				}
				{isOwner&& <AccountOwnerOptions/>}
			</div>
			<div style={{height:'100%',overflow:'hidden',border:'1px solid #ccc',borderRadius:'8px'}}>
				<div style={{background:'#00041c',color:'#fff',flex:'0 0 auto'}}>
					<div style={{
						display:'flex',
						alignItems:'center',
						padding:'8px'
					}}>
						<span className="ml-auto">
							{isOwner?'Complete/Total':'Status'}
						</span>
					</div>
				</div>
				<div style={{height:'100%',overflow:'auto'}}>
					{ 
						isClient?
						sessions.map(session=><Session session={session} showName={false}/>)
						:
						aggregates.map( 
							data => <ClientSessionsRow key={data.client_id} data={data} /> 
						) 
					}
					<div style={{height:'80px'}}/>
				</div>
			</div>
		</div>
	)
}

export default Sessions